// Definizione di un campo utente dinamico per organizzazione.
// Schema descritto in specs/030-campi-utente-odv/data-model.md; dalla feature 051 le
// definizioni vivono in LocalApi e sono discriminate per entità di dominio.

import type { EntitaCampoUtente } from './generated/entita-campo-utente';

export enum TipoCampoUtente {
  Testo    = 0,
  Numero   = 1,
  Booleano = 2,
  Lista    = 3,
}

export interface CampoUtenteDef {
  organizzazioneId: number;
  entita: EntitaCampoUtente;
  codice: string;
  etichetta: string;
  tipoCampo: TipoCampoUtente;
  valoriAmmessiJson: string | null;
  ordinamento: number;
  isActive: boolean;
  codiceEsolver?: string | null; // codice ESOLVER di origine (picker ZVIEWCAMPIUTENTE); null se manuale
  posizioneEsolver?: number | null; // posizione (1-60) del ValoreCampoN ESOLVER; obbligatoria per Entita.Articolo
  dataCreazione?: string;
  dataModifica?: string;
  executedBy: string | null;

  // Detail base (errori da pipeline backend, opzionali)
  hasErrors?: boolean;
  errorType?: number | null;
  errorMessage?: string | null;
}

// Mirror di CampoUtenteDefEsolver (LocalApi.Esolver ← vista ZVIEWCAMPIUTENTE):
// catalogo dei campi utente abilitati in ESOLVER per ambito (ORP = Ordine Produzione).
export interface CampoUtenteDefEsolver {
  codiceCampoUtente: string;
  descrizione: string;
  posizione: number;
  tipoDato: number;
  lunghezzaMassima: number;
  numeroDecimali: number;
  elencoValori: number;
  ambitoUtilizzo: string;
  dettaglioAmbito: number;
  numeroProgrVisualizz: number;
  campoObbligatorio: number;
}

// Mirror di CampoUtenteDoc (sp_GetCampiUtentePerDocumento): valore di un campo utente
// su un documento ESOLVER (idRigaDoc = 0 → valore di testata).
export interface CampoUtenteDoc {
  dbGruppo: string;
  idDocumento: number;
  idRigaDoc: number;
  codiceCampoUtente: string;
  posizione: number;
  descrizione: string;
  valore: string;
}
